"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _colors = _interopRequireDefault(require("./colors"));
var _font = _interopRequireDefault(require("./font"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var general = {
  // General
  primary: _colors["default"].black,
  secondary: _colors["default"].white,
  accent: _colors["default"].red,
  background: _colors["default"].white,
  backgroundColorDisabled: _colors["default"].coolGray3,
  // Messaging Types
  success: _colors["default"].green,
  info: _colors["default"].blue,
  warning: _colors["default"].yellow,
  error: _colors["default"].orange,
  disabled: _colors["default"].coolGray3,
  textColorSuccess: _colors["default"].white,
  textColorInfo: _colors["default"].white,
  textColorWarning: _colors["default"].black,
  textColorError: _colors["default"].black,
  textColorDisabled: _colors["default"].white,
  // Borders
  borderWidth: (0, _javascriptStyleHelpers.calculateRem)(1),
  borderStyle: "solid",
  borderColor: _colors["default"].coolGray3,
  border: "".concat((0, _javascriptStyleHelpers.calculateRem)(1), " solid ").concat(_colors["default"].coolGray3),
  borderColorDisabled: _colors["default"].coolGray3,
  // Links
  linkColor: _colors["default"].black,
  linkColorHover: _colors["default"].blue,
  linkColorActive: _colors["default"].blue,
  linkDecoration: "underline",
  // Transitions
  transitionDuration: "0.2s",
  // Horizontal Rule
  hrPrimary: "".concat((0, _javascriptStyleHelpers.calculateRem)(4), " solid ").concat(_colors["default"].charcoal),
  hrSecondary: "".concat((0, _javascriptStyleHelpers.calculateRem)(1), " solid ").concat(_colors["default"].charcoal),
  hrTertiary: "".concat((0, _javascriptStyleHelpers.calculateRem)(1), " solid ").concat(_colors["default"].coolGray3)
};
var verizonTheme = _objectSpread(_objectSpread(_objectSpread({}, _colors["default"]), _font["default"]), general);
var _default = verizonTheme;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/theme/dist/cjs/verizonTheme/index.js
// module id = 1616
// module chunks = 0